import React from 'react';
import { ArrowRight, Mail, Clock } from 'lucide-react';

export default function LegalSidePanel({ onOpenContactModal }) {
  return (
    <div
      className="lg:sticky lg:top-28"
      data-testid="legal-side-panel"
    >
      <div
        className="rounded-xl border p-6"
        style={{
          borderColor: '#E2E8F0',
          boxShadow: 'var(--kv-shadow-md)',
        }}
      >
        <h3
          className="text-base font-bold mb-2"
          style={{ color: '#131B2E', letterSpacing: '-0.01em' }}
        >
          Need Help or Have Questions?
        </h3>

        <p
          className="text-sm mb-5"
          style={{ color: '#475569', lineHeight: '1.6' }}
        >
          Our team is available to clarify any terms or assist you with your project requirements.
        </p>

        <div className="space-y-3 mb-5">
          <div className="flex items-center gap-2.5">
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
              style={{ backgroundColor: 'rgba(10, 61, 145, 0.05)' }}
            >
              <Mail className="w-4 h-4" style={{ color: '#0A3D91' }} />
            </div>
            <div>
              <p className="text-xs" style={{ color: '#475569' }}>Email</p>
              <a
                href="mailto:hello@kritvasoft.com"
                className="text-sm font-medium"
                style={{ color: '#0A3D91' }}
                data-testid="side-panel-email"
              >
                hello@kritvasoft.com
              </a>
            </div>
          </div>

          <div className="flex items-center gap-2.5">
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
              style={{ backgroundColor: 'rgba(10, 61, 145, 0.05)' }}
            >
              <Clock className="w-4 h-4" style={{ color: '#0A3D91' }} />
            </div>
            <div>
              <p className="text-xs" style={{ color: '#475569' }}>Response time</p>
              <p className="text-sm font-medium" style={{ color: '#131B2E' }}>Within 24 hours</p>
            </div>
          </div>
        </div>

        <button
          onClick={onOpenContactModal}
          className="kv-btn-primary w-full justify-center"
          data-testid="side-panel-cta"
        >
          Book a Strategy Call
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
